import React, { useEffect, useState } from 'react';
import useUiContext from '@groupefungo/react-apollo.core/ui/UseContext';
import { formattedDate, formatToClockTime } from "../utils/parser";
import ContinueButton from "../../booking-system/appointment-booking/src/components/ui/ContinueButton";
import useCalendarToolGql from './gql/useCalendarToolGql';
import CoolLoading from '../../wedding-wardrobe/src/components/base/CoolLoading';


function BookingCalendarAvailabilities(props) {
  const { selectedCalendarDay, handleSelectHour, handleContinue, appointmentType, processData, selectedAvailability } = props;
  const { Button, Typography } = useUiContext();
  const { date } = selectedCalendarDay;
  const { useBookingCalendarToolQuery } = useCalendarToolGql({ withAvailabilities: true, view: 'Day', appointmentType });
  const { loading, data, error } = useBookingCalendarToolQuery(date);

  if (error) console.log('error', error);
  if (loading) return <CoolLoading />;

  const {
    calendarTool: {
      calendar: {
        beginningOfDay: {
          hours,
        },
      },
    } } = data;

  const availabilities = hours.reduce(
    (accumulator, currentValue) => {
      accumulator.push(currentValue.availability)
      return accumulator;
    }, []
  );

  const hasFreeSlots = availabilities && availabilities.some((a) => a.hasFreeSlot && !a.disabled && a.usersAvailabilities.find((ua) => ua.appointmentTypes.includes(appointmentType) && ua.status === 'free'));

  return (
    <div className="inner-content">
      <div>
        {!hasFreeSlots && (
          <Typography variant="h2" className="no-availabilities">
            No availabilities for this date
          </Typography>
        )}
        <div className="hours-buttons-list">
          {hasFreeSlots && availabilities.filter((a) => !a.disabled).map((a) => {
            const usersAvailability = a.usersAvailabilities.find((ua) => ua.status === 'free' && ua.appointmentTypes.includes(appointmentType));
            return (usersAvailability
              && (
                <Button
                  id={usersAvailability.id}
                  onClick={handleSelectHour(usersAvailability.id)}
                >{formatToClockTime(formattedDate(a.from))}
                </Button>
              )
            );
          })}
        </div>
        <ContinueButton
          onClick={handleContinue}
          displayIn={selectedAvailability !== '-1'}
          buttonClass="primary-btn left-align"
          loading={processData}
        />
      </div>
      <Typography variant="body1" className="concierge-notice">
        If you are unable to find an appointment, we invite you to call or text our concierge now at <a
        href="tel:2125831700">212-583-1700</a>.
      </Typography>
    </div>
  )
}

export default BookingCalendarAvailabilities;